import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import * as React from "react";
import { useMemo, forwardRef, useState, useCallback, useId as useId$1, useRef, useEffect, useLayoutEffect } from "react";
import * as ReactDOM from "react-dom";
import './index.css';function SystemIcon$1({
  "aria-label": ariaLabel,
  children,
  className,
  name,
  isPhosphor = false,
  size,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    "i",
    {
      ...props,
      className: `systemIconBase${className ? ` ${className}` : ""}`,
      "data-stb-system-icon": "true",
      "data-component-info": `pretzel-system-icon,${isPhosphor ? "phosphor" : "storebrand"},${name}`,
      "data-phosphor-icons": isPhosphor,
      style: size ? {
        height: `${size / 16}rem`,
        width: `${size / 16}rem`,
        fontSize: `${size / 16}rem`,
        lineHeight: `${size / 16}rem`
      } : {},
      role: ariaLabel ? "img" : void 0,
      "aria-hidden": ariaLabel ? void 0 : "true",
      title: ariaLabel,
      translate: "no",
      children: name || children
    }
  );
}
const typeToIcon = {
  info: "information-filled",
  "info-subtle": "information-filled",
  success: "check-circle-filled",
  warning: "warning-filled",
  error: "error-filled"
};
function AlertInline({
  title,
  variant = "info-subtle",
  role,
  className,
  ...props
}) {
  const icon = useMemo(() => typeToIcon == null ? void 0 : typeToIcon[variant], [variant]);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ...props,
      className: `alertInlineBase${className ? ` ${className}` : ""}`,
      "data-variant": variant,
      "data-stb-alert-inline": "true",
      "data-component-info": "pretzel-alert-inline",
      children: [
        /* @__PURE__ */ jsx(SystemIcon$1, { className: "alertIcon font-small-demibold", name: icon }),
        /* @__PURE__ */ jsx("div", { role, className: "alertTitle font-small-demibold", children: title })
      ]
    }
  );
}
const getSpinnerSize$1 = (size) => {
  switch (size) {
    case "xxsmall":
      return 16;
    case "xsmall":
      return 20;
    case "small":
      return 24;
    case "medium":
      return 48;
    case "large":
    default:
      return 96;
  }
};
const getStrokeSize$1 = (size) => {
  switch (size) {
    case "xxsmall":
    case "xsmall":
      return getSpinnerSize$1(size) / 5;
    case "small":
    case "medium":
      return getSpinnerSize$1(size) / 6;
    case "large":
    default:
      return getSpinnerSize$1(size) / 10;
  }
};
const LoadingIndicatorSpinner$1 = forwardRef(
  ({
    size = "large",
    loadingText,
    colorVariant = "onWhite",
    className,
    ...props
  }, ref) => {
    const spinnerSize = getSpinnerSize$1(size);
    const stroke = getStrokeSize$1(size);
    const cx = spinnerSize / 2;
    const cy = spinnerSize / 2;
    const innerRadius = spinnerSize / 2 - stroke / 2;
    return /* @__PURE__ */ jsxs(
      "div",
      {
        ...props,
        className: `spinnerContainer ${size} ${colorVariant}${className ? ` ${className}` : ""}`,
        "data-stb-spinner": "true",
        "data-component-info": "pretzel-spinner",
        role: "progressbar",
        "aria-busy": true,
        "aria-label": loadingText ?? "Loading...",
        ref,
        children: [
          /* @__PURE__ */ jsxs(
            "svg",
            {
              className: `spinner ${colorVariant}`,
              version: "1.1",
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: `0 0 ${spinnerSize} ${spinnerSize}`,
              height: spinnerSize,
              width: spinnerSize,
              children: [
                /* @__PURE__ */ jsx(
                  "circle",
                  {
                    className: "spinnerTrack",
                    cx,
                    cy: cx,
                    r: innerRadius,
                    fill: "none",
                    strokeWidth: stroke
                  }
                ),
                /* @__PURE__ */ jsx(
                  "circle",
                  {
                    className: "spinnerInMotion",
                    cx,
                    cy,
                    r: innerRadius,
                    fill: "none",
                    strokeWidth: stroke
                  }
                )
              ]
            }
          ),
          loadingText && size === "large" && /* @__PURE__ */ jsx("p", { className: "font-body", children: loadingText }),
          loadingText && size === "medium" && /* @__PURE__ */ jsx("p", { className: "font-small", children: loadingText })
        ]
      }
    );
  }
);
const buttonFontClassFrom$1 = (size) => {
  switch (size) {
    case "large":
      return "font-button";
    case "small":
      return "font-button-small";
    case "medium":
    default:
      return "font-button-mobile";
  }
};
const toSpinnerSize$1 = (size) => {
  switch (size) {
    case "small":
      return "xxsmall";
    case "medium":
      return "xsmall";
    case "large":
    default:
      return "small";
  }
};
const fixedForwardRef$1 = forwardRef;
function ButtonWithForwardRef$1(props, ref) {
  const {
    disabled,
    variant = "primary",
    loading = false,
    iconLeft = "",
    iconRight = "",
    showDefaultIcon = true,
    onClick,
    children,
    size = "large",
    type = "button",
    className,
    id,
    as: Element2 = "button",
    ...rest
  } = props;
  const shouldHaveDefaultIcon = showDefaultIcon && variant === "tertiary" && !iconRight && !iconLeft;
  const shouldBeUnderlined = variant === "tertiary" && !iconRight && !iconLeft && !shouldHaveDefaultIcon;
  function handleClick() {
    if (disabled || loading) {
      return (e) => e.preventDefault();
    }
    return onClick;
  }
  function renderLoading() {
    return loading && /* @__PURE__ */ jsx(
      LoadingIndicatorSpinner$1,
      {
        size: toSpinnerSize$1(size),
        colorVariant: "onRed"
      }
    );
  }
  function renderContent() {
    return !loading && /* @__PURE__ */ jsxs(Fragment, { children: [
      iconLeft && /* @__PURE__ */ jsx("i", { className: "systemIcon iconLeft", translate: "no", "aria-hidden": true, children: iconLeft }),
      children && /* @__PURE__ */ jsx("span", { children }),
      shouldHaveDefaultIcon && /* @__PURE__ */ jsx("i", { className: "systemIcon iconRight", translate: "no", "aria-hidden": true, children: "arrow_right" }),
      iconRight && /* @__PURE__ */ jsx("i", { className: "systemIcon iconRight", translate: "no", "aria-hidden": true, children: iconRight })
    ] });
  }
  return /* @__PURE__ */ jsxs(
    Element2,
    {
      ...rest,
      id,
      ref,
      "data-stb-button": "true",
      "data-component-info": "pretzel-button",
      "data-loading": loading ? true : null,
      "data-variant": variant,
      "data-size": size,
      "aria-disabled": disabled,
      role: Element2 === "a" ? "link" : null,
      onClick: handleClick(),
      type: Element2 === "button" ? type : void 0,
      disabled,
      className: `button font-button-large ${buttonFontClassFrom$1(size)}${shouldBeUnderlined ? " underlined" : ""}${className ? ` ${className}` : ""}`,
      tabIndex: "0",
      href: Element2 === "a" ? rest.href : void 0,
      children: [
        renderLoading(),
        renderContent()
      ]
    }
  );
}
fixedForwardRef$1(ButtonWithForwardRef$1);
function ButtonBrandWithForwardedRef$1(props, ref) {
  const {
    disabled,
    loading = false,
    iconLeft = "",
    iconRight = "",
    onClick,
    children,
    as = "button",
    type = "button",
    className,
    as: Element2 = "button",
    ...rest
  } = props;
  function handleClick() {
    if (disabled || loading) {
      return (e) => e.preventDefault();
    }
    return onClick;
  }
  function renderLoading() {
    return loading && /* @__PURE__ */ jsx(LoadingIndicatorSpinner$1, { size: "small", colorVariant: "onRed" });
  }
  function renderContent() {
    return !loading && /* @__PURE__ */ jsxs(Fragment, { children: [
      iconLeft && /* @__PURE__ */ jsx("i", { className: "systemIcon iconLeft", translate: "no", "aria-hidden": true, children: iconLeft }),
      /* @__PURE__ */ jsx("span", { children }),
      iconRight && /* @__PURE__ */ jsx("i", { className: "systemIcon iconRight", translate: "no", "aria-hidden": true, children: iconRight })
    ] });
  }
  return /* @__PURE__ */ jsxs(
    Element2,
    {
      ...rest,
      ref,
      "data-stb-button-brand": "true",
      "data-component-info": "pretzel-button-brand",
      "data-loading": loading ? true : null,
      "aria-disabled": disabled,
      role: as === "a" ? "link" : null,
      onClick: handleClick(),
      type: as === "button" ? type : void 0,
      disabled,
      className: `buttonBrand font-button-large${className ? ` ${className}` : ""}`,
      tabIndex: "0",
      href: Element2 === "a" ? rest.href : void 0,
      children: [
        renderLoading(),
        renderContent()
      ]
    }
  );
}
fixedForwardRef$1(ButtonBrandWithForwardedRef$1);
function ButtonCircleWithForwardedRef$1(props, ref) {
  const {
    disabled,
    variant = "primary",
    loading = false,
    iconName,
    onClick,
    as = "button",
    type = "button",
    className,
    "aria-label": ariaLabel,
    as: Element2 = "button",
    size = "large",
    ...rest
  } = props;
  function handleClick() {
    if (disabled || loading) {
      return (e) => e.preventDefault();
    }
    return onClick;
  }
  function renderLoading() {
    return loading && /* @__PURE__ */ jsx(
      LoadingIndicatorSpinner$1,
      {
        size: toSpinnerSize$1(size),
        colorVariant: "onRed"
      }
    );
  }
  function renderContent() {
    return !loading && iconName && /* @__PURE__ */ jsx("i", { className: "systemIcon", translate: "no", "aria-hidden": true, children: iconName });
  }
  return /* @__PURE__ */ jsxs(
    Element2,
    {
      ...rest,
      ref,
      "data-stb-button-circle": "true",
      "data-component-info": "pretzel-button-circle",
      "data-loading": loading ? true : null,
      "data-variant": variant,
      "data-size": size,
      "aria-disabled": disabled,
      "aria-label": ariaLabel,
      role: as === "a" ? "link" : null,
      onClick: handleClick(),
      type: as === "button" ? type : void 0,
      disabled,
      className: `buttonCircle font-button-large${className ? ` ${className}` : ""}`,
      tabIndex: "0",
      href: Element2 === "a" ? rest.href : void 0,
      children: [
        renderLoading(),
        renderContent()
      ]
    }
  );
}
fixedForwardRef$1(ButtonCircleWithForwardedRef$1);
function ButtonCircleBrandWithForwardedRef$1(props, ref) {
  const {
    disabled,
    loading = false,
    iconName,
    onClick,
    as = "button",
    type = "button",
    className,
    "aria-label": ariaLabel,
    as: Element2 = "button",
    ...rest
  } = props;
  function handleClick() {
    if (disabled || loading) {
      return (e) => e.preventDefault();
    }
    return onClick;
  }
  function renderLoading() {
    return loading && /* @__PURE__ */ jsx(LoadingIndicatorSpinner$1, { size: "small", colorVariant: "onRed" });
  }
  function renderContent() {
    return !loading && iconName && /* @__PURE__ */ jsx("i", { className: "systemIcon", translate: "no", "aria-hidden": true, children: iconName });
  }
  return /* @__PURE__ */ jsxs(
    Element2,
    {
      ...rest,
      ref,
      "data-stb-button-circle-brand": "true",
      "data-component-info": "pretzel-button-circle-brand",
      "data-loading": loading ? true : null,
      "aria-disabled": disabled,
      "aria-label": ariaLabel,
      role: as === "a" ? "link" : null,
      onClick: handleClick(),
      type: as === "button" ? type : void 0,
      disabled,
      className: `buttonCircleBrand font-button-large${className ? ` ${className}` : ""}`,
      tabIndex: "0",
      href: Element2 === "a" ? rest.href : void 0,
      children: [
        renderLoading(),
        renderContent()
      ]
    }
  );
}
fixedForwardRef$1(
  ButtonCircleBrandWithForwardedRef$1
);
function ButtonIconWithForwardedRef$1(props, ref) {
  const {
    iconName,
    disabled,
    onClick,
    size = "medium",
    as = "button",
    type = "button",
    className,
    "aria-label": ariaLabel,
    as: Element2 = "button",
    ...rest
  } = props;
  function handleClick() {
    if (disabled) {
      return (e) => e.preventDefault();
    }
    return onClick;
  }
  return /* @__PURE__ */ jsx(
    Element2,
    {
      ...rest,
      ref,
      "data-stb-button-icon": "true",
      "data-component-info": "pretzel-button-icon",
      "aria-disabled": disabled,
      "aria-label": ariaLabel,
      role: as === "a" ? "link" : null,
      onClick: handleClick(),
      "data-size": size,
      type: as === "button" ? type : void 0,
      disabled,
      className: `buttonIcon ${className ? ` ${className}` : ""}`,
      tabIndex: "0",
      href: Element2 === "a" ? rest.href : void 0,
      children: /* @__PURE__ */ jsx("i", { "aria-hidden": true, translate: "no", children: iconName })
    }
  );
}
const ButtonIcon$1 = fixedForwardRef$1(ButtonIconWithForwardedRef$1);
function SystemIcon({
  "aria-label": ariaLabel,
  children,
  className,
  name,
  isPhosphor = false,
  size,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    "i",
    {
      ...props,
      className: `systemIconBase${className ? ` ${className}` : ""}`,
      "data-stb-system-icon": "true",
      "data-component-info": `pretzel-system-icon,${isPhosphor ? "phosphor" : "storebrand"},${name}`,
      "data-phosphor-icons": isPhosphor,
      style: size ? {
        height: `${size / 16}rem`,
        width: `${size / 16}rem`,
        fontSize: `${size / 16}rem`,
        lineHeight: `${size / 16}rem`
      } : {},
      role: ariaLabel ? "img" : void 0,
      "aria-hidden": ariaLabel ? void 0 : "true",
      title: ariaLabel,
      translate: "no",
      children: name || children
    }
  );
}
const Input = forwardRef(
  ({
    name,
    disabled,
    readOnly,
    icon,
    onIconClick,
    iconButtonProps,
    size = "medium",
    suffix,
    type = "text",
    rows = 6,
    as = "input",
    suffixProps,
    alertMessageType,
    onChange,
    id,
    className,
    ...props
  }, ref) => {
    const suffixId = `${name}-input-suffix`;
    const isTextArea = as === "textarea";
    let InputElement;
    if (isTextArea) {
      InputElement = "textarea";
    } else {
      InputElement = "input";
    }
    const renderInput = () => /* @__PURE__ */ jsx(
      InputElement,
      {
        ...props,
        className: `font-paragraph inputElement${isTextArea ? " textarea" : " input"}`,
        id: id || name,
        readOnly,
        rows: isTextArea ? rows : null,
        name,
        type,
        icon,
        onChange,
        "aria-invalid": alertMessageType === "error",
        disabled,
        "aria-disabled": disabled,
        ref
      }
    );
    return /* @__PURE__ */ jsxs(
      "div",
      {
        className: `inputContainer${className ? ` ${className}` : ""}  ${isTextArea ? " textarea" : " input"}`,
        "aria-disabled": disabled,
        "aria-readonly": readOnly,
        "data-read-only": readOnly,
        "data-message-type": alertMessageType,
        "data-variant": alertMessageType,
        "data-stb-input-atom": "true",
        "data-component-info": "pretzel-input-atom",
        "data-size": size,
        children: [
          renderInput(),
          Boolean(suffix || icon) && /* @__PURE__ */ jsxs("div", { className: "inputAdditions font-body", children: [
            Boolean(suffix) && /* @__PURE__ */ jsx(
              "div",
              {
                className: "font-body inputSuffix",
                id: suffixId,
                ...suffixProps,
                children: suffix
              }
            ),
            Boolean(icon) && Boolean(onIconClick) && /* @__PURE__ */ jsx(
              ButtonIcon$1,
              {
                ...iconButtonProps,
                iconName: icon,
                className: "iconButton",
                size: "medium",
                onClick: onIconClick,
                disabled: disabled || readOnly || false,
                "aria-label": icon
              }
            ),
            Boolean(icon) && Boolean(onIconClick) === false && /* @__PURE__ */ jsx("span", { className: "icon", children: /* @__PURE__ */ jsx(SystemIcon, { name: icon }) })
          ] })
        ]
      }
    );
  }
);
const LINE_HEIGHT = 27;
function Hint({
  children,
  hintMaxLines = 2,
  hintReadLessLabel = "Read less",
  hintReadMoreLabel = "Read more",
  className = "",
  hintDisabledStyle = false,
  ...props
}) {
  const [open, setOpen] = useState(false);
  const [lines, setLines] = useState(0);
  const ref = useRef();
  useEffect(() => {
    const { offsetHeight: height } = ref.current;
    setLines(height / LINE_HEIGHT);
  }, []);
  const textStyle = () => {
    if (lines !== 0 && !open) {
      return {
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        WebkitLineClamp: hintMaxLines,
        WebkitBoxOrient: "vertical"
      };
    }
    return {};
  };
  return /* @__PURE__ */ jsxs(
    "span",
    {
      ...props,
      className: `font-body-small hintBase${className ? ` ${className}` : ""}`,
      ref,
      "data-stb-hint": "true",
      "data-component-info": "pretzel-hint",
      "data-disabled-style": hintDisabledStyle,
      children: [
        /* @__PURE__ */ jsx("span", { className: "font-body-small hintText", style: textStyle(), children }),
        Boolean(lines > hintMaxLines) && /* @__PURE__ */ jsx(
          "button",
          {
            className: "font-body-small hintButton",
            type: "button",
            onClick: () => setOpen(!open),
            children: open ? hintReadLessLabel : hintReadMoreLabel
          }
        )
      ]
    }
  );
}
function hasWindow() {
  return typeof window !== "undefined";
}
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || "").toLowerCase();
  }
  return "#document";
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (!hasWindow() || typeof ShadowRoot === "undefined") {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !["inline", "contents"].includes(display);
}
function isTableElement(element) {
  return ["table", "td", "th"].includes(getNodeName(element));
}
function isTopLayer(element) {
  return [":popover-open", ":modal"].some((selector) => {
    try {
      return element.matches(selector);
    } catch (e) {
      return false;
    }
  });
}
function isContainingBlock(elementOrCss) {
  const webkit = isWebKit();
  const css = isElement(elementOrCss) ? getComputedStyle(elementOrCss) : elementOrCss;
  return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || ["transform", "perspective", "filter"].some((value) => (css.willChange || "").includes(value)) || ["paint", "layout", "strict", "content"].some((value) => (css.contain || "").includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else if (isTopLayer(currentNode)) {
      return null;
    }
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === "undefined" || !CSS.supports) return false;
  return CSS.supports("-webkit-backdrop-filter", "none");
}
function isLastTraversableNode(node) {
  return ["html", "body", "#document"].includes(getNodeName(node));
}
function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.scrollX,
    scrollTop: element.scrollY
  };
}
function getParentNode(node) {
  if (getNodeName(node) === "html") {
    return node;
  }
  const result = (
    // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node)
  );
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}
function contains(parent, child) {
  if (!parent || !child) {
    return false;
  }
  const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
  if (parent.contains(child)) {
    return true;
  }
  if (rootNode && isShadowRoot(rootNode)) {
    let next = child;
    while (next) {
      if (parent === next) {
        return true;
      }
      next = next.parentNode || next.host;
    }
  }
  return false;
}
function isReactEvent(event) {
  return "nativeEvent" in event;
}
function isRootElement(element) {
  return element.matches("html,body");
}
function getDocument(node) {
  return (node == null ? void 0 : node.ownerDocument) || document;
}
function isEventTargetWithin(event, node) {
  if (node == null) {
    return false;
  }
  if ("composedPath" in event) {
    return event.composedPath().includes(node);
  }
  const e = event;
  return e.target != null && node.contains(e.target);
}
function getTarget(event) {
  if ("composedPath" in event) {
    return event.composedPath()[0];
  }
  return event.target;
}
const sides = ["top", "right", "bottom", "left"];
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = (v) => ({
  x: v,
  y: v
});
const oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
const oppositeAlignmentMap = {
  start: "end",
  end: "start"
};
function clamp(start, value, end) {
  return max(start, min(value, end));
}
function evaluate(value, param) {
  return typeof value === "function" ? value(param) : value;
}
function getSide(placement) {
  return placement.split("-")[0];
}
function getAlignment(placement) {
  return placement.split("-")[1];
}
function getOppositeAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
  return axis === "y" ? "height" : "width";
}
function getSideAxis(placement) {
  return ["top", "bottom"].includes(getSide(placement)) ? "y" : "x";
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, (alignment) => oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
  const lr = ["left", "right"];
  const rl = ["right", "left"];
  const tb = ["top", "bottom"];
  const bt = ["bottom", "top"];
  switch (side) {
    case "top":
    case "bottom":
      if (rtl) return isStart ? rl : lr;
      return isStart ? lr : rl;
    case "left":
    case "right":
      return isStart ? tb : bt;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === "start", rtl);
  if (alignment) {
    list = list.map((side) => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, (side) => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== "number" ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  const {
    x,
    y,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y,
    left: x,
    right: x + width,
    bottom: y + height,
    x,
    y
  };
}
function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === "y";
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case "top":
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case "bottom":
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case "right":
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case "left":
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case "start":
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case "end":
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}
const computePosition$1 = async (reference, floating, config) => {
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2
  } = config;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(floating));
  let rects = await platform2.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i = 0; i < validMiddleware.length; i++) {
    const {
      name,
      fn
    } = validMiddleware[i];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform: platform2,
      elements: {
        reference,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === "object") {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform2.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
    }
  }
  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x,
    y,
    platform: platform2,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = "clippingAncestors",
    rootBoundary = "viewport",
    elementContext = "floating",
    altBoundary = false,
    padding = 0
  } = evaluate(options, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === "floating" ? "reference" : "floating";
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform2.getClippingRect({
    element: ((_await$platform$isEle = await (platform2.isElement == null ? void 0 : platform2.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements.floating)),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === "floating" ? {
    x,
    y,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements.floating));
  const offsetScale = await (platform2.isElement == null ? void 0 : platform2.isElement(offsetParent)) ? await (platform2.getScale == null ? void 0 : platform2.getScale(offsetParent)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}
const flip$2 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "flip",
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform: platform2,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = "bestFit",
        fallbackAxisSideDirection = "none",
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = getSide(placement);
      const initialSideAxis = getSideAxis(initialPlacement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
      if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides2 = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides2[0]], overflow[sides2[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];
      if (!overflows.every((side2) => side2 <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          return {
            data: {
              index: nextIndex,
              overflows: overflowsData
            },
            reset: {
              placement: nextPlacement
            }
          };
        }
        let resetPlacement = (_overflowsData$filter = overflowsData.filter((d) => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case "bestFit": {
              var _overflowsData$filter2;
              const placement2 = (_overflowsData$filter2 = overflowsData.filter((d) => {
                if (hasFallbackAxisSideDirection) {
                  const currentSideAxis = getSideAxis(d.placement);
                  return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  currentSideAxis === "y";
                }
                return true;
              }).map((d) => [d.placement, d.overflows.filter((overflow2) => overflow2 > 0).reduce((acc, overflow2) => acc + overflow2, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
              if (placement2) {
                resetPlacement = placement2;
              }
              break;
            }
            case "initialPlacement":
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};
function getSideOffsets(overflow, rect) {
  return {
    top: overflow.top - rect.height,
    right: overflow.right - rect.width,
    bottom: overflow.bottom - rect.height,
    left: overflow.left - rect.width
  };
}
function isAnySideFullyClipped(overflow) {
  return sides.some((side) => overflow[side] >= 0);
}
const hide$2 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "hide",
    options,
    async fn(state) {
      const {
        rects
      } = state;
      const {
        strategy = "referenceHidden",
        ...detectOverflowOptions
      } = evaluate(options, state);
      switch (strategy) {
        case "referenceHidden": {
          const overflow = await detectOverflow(state, {
            ...detectOverflowOptions,
            elementContext: "reference"
          });
          const offsets = getSideOffsets(overflow, rects.reference);
          return {
            data: {
              referenceHiddenOffsets: offsets,
              referenceHidden: isAnySideFullyClipped(offsets)
            }
          };
        }
        case "escaped": {
          const overflow = await detectOverflow(state, {
            ...detectOverflowOptions,
            altBoundary: true
          });
          const offsets = getSideOffsets(overflow, rects.floating);
          return {
            data: {
              escapedOffsets: offsets,
              escaped: isAnySideFullyClipped(offsets)
            }
          };
        }
        default: {
          return {};
        }
      }
    }
  };
};
async function convertValueToCoords(state, options) {
  const {
    placement,
    platform: platform2,
    elements
  } = state;
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === "y";
  const mainAxisMulti = ["left", "top"].includes(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options, state);
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === "number" ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: rawValue.mainAxis || 0,
    crossAxis: rawValue.crossAxis || 0,
    alignmentAxis: rawValue.alignmentAxis
  };
  if (alignment && typeof alignmentAxis === "number") {
    crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}
const offset$2 = function(options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: "offset",
    options,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x,
        y,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options);
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x + diffCoords.x,
        y: y + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};
const shift$2 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "shift",
    options,
    async fn(state) {
      const {
        x,
        y,
        placement
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: (_ref) => {
            let {
              x: x2,
              y: y2
            } = _ref;
            return {
              x: x2,
              y: y2
            };
          }
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const coords = {
        x,
        y
      };
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const crossAxis = getSideAxis(getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === "y" ? "top" : "left";
        const maxSide = mainAxis === "y" ? "bottom" : "right";
        const min2 = mainAxisCoord + overflow[minSide];
        const max2 = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min2, mainAxisCoord, max2);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === "y" ? "top" : "left";
        const maxSide = crossAxis === "y" ? "bottom" : "right";
        const min2 = crossAxisCoord + overflow[minSide];
        const max2 = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min2, crossAxisCoord, max2);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x,
          y: limitedCoords.y - y,
          enabled: {
            [mainAxis]: checkMainAxis,
            [crossAxis]: checkCrossAxis
          }
        }
      };
    }
  };
};
function getCssDimensions(element) {
  const css = getComputedStyle(element);
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}
function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}
function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? round(rect.width) : rect.width) / width;
  let y = ($ ? round(rect.height) : rect.height) / height;
  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}
const noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) {
    return false;
  }
  return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = getFrameElement(currentWin);
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentWin = getWindow(currentIFrame);
      currentIFrame = getFrameElement(currentWin);
    }
  }
  return rectToClientRect({
    width,
    height,
    x,
    y
  });
}
function getWindowScrollBarX(element, rect) {
  const leftScroll = getNodeScroll(element).scrollLeft;
  if (!rect) {
    return getBoundingClientRect(getDocumentElement(element)).left + leftScroll;
  }
  return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
  if (ignoreScrollbarX === void 0) {
    ignoreScrollbarX = false;
  }
  const htmlRect = documentElement.getBoundingClientRect();
  const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : (
    // RTL <body> scrollbar.
    getWindowScrollBarX(documentElement, htmlRect)
  ));
  const y = htmlRect.top + scroll.scrollTop;
  return {
    x,
    y
  };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed = strategy === "fixed";
  const documentElement = getDocumentElement(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll, true) : createCoords(0);
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
  };
}
function getClientRects(element) {
  return Array.from(element.getClientRects());
}
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;
  if (getComputedStyle(body).direction === "rtl") {
    x += max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}
function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x,
    y
  };
}
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === "fixed");
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === "viewport") {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === "document") {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y,
      width: clippingAncestor.width,
      height: clippingAncestor.height
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle(parentNode).position === "fixed" || hasFixedPositionAncestor(parentNode, stopNode);
}
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter((el) => isElement(el) && getNodeName(el) !== "body");
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle(element).position === "fixed";
  let currentNode = elementIsFixed ? getParentNode(element) : element;
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === "fixed") {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && ["absolute", "fixed"].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      result = result.filter((ancestor) => ancestor !== currentNode);
    } else {
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === "clippingAncestors" ? isTopLayer(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}
function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === "fixed";
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
  const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
  return {
    x,
    y,
    width: rect.width,
    height: rect.height
  };
}
function isStaticPositioned(element) {
  return getComputedStyle(element).position === "static";
}
function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement(element) || getComputedStyle(element).position === "fixed") {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  let rawOffsetParent = element.offsetParent;
  if (getDocumentElement(element) === rawOffsetParent) {
    rawOffsetParent = rawOffsetParent.ownerDocument.body;
  }
  return rawOffsetParent;
}
function getOffsetParent(element, polyfill) {
  const win = getWindow(element);
  if (isTopLayer(element)) {
    return win;
  }
  if (!isHTMLElement(element)) {
    let svgOffsetParent = getParentNode(element);
    while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
      if (isElement(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = getParentNode(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) {
    return win;
  }
  return offsetParent || getContainingBlock(element) || win;
}
const getElementRects = async function(data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  const floatingDimensions = await getDimensionsFn(data.floating);
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      width: floatingDimensions.width,
      height: floatingDimensions.height
    }
  };
};
function isRTL(element) {
  return getComputedStyle(element).direction === "rtl";
}
const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement,
  isRTL
};
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = getDocumentElement(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const {
      left,
      top,
      width,
      height
    } = element.getBoundingClientRect();
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1e3);
        } else {
          refresh(false, ratio);
        }
      }
      isFirstUpdate = false;
    }
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root.ownerDocument
      });
    } catch (e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === "function",
    layoutShift = typeof IntersectionObserver === "function",
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...referenceEl ? getOverflowAncestors(referenceEl) : [], ...getOverflowAncestors(floating)] : [];
  ancestors.forEach((ancestor) => {
    ancestorScroll && ancestor.addEventListener("scroll", update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener("resize", update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver((_ref) => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach((ancestor) => {
      ancestorScroll && ancestor.removeEventListener("scroll", update);
      ancestorResize && ancestor.removeEventListener("resize", update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}
const offset$1 = offset$2;
const shift$1 = shift$2;
const flip$1 = flip$2;
const hide$1 = hide$2;
const computePosition = (reference, floating, options) => {
  const cache = /* @__PURE__ */ new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition$1(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};
var index$1 = typeof document !== "undefined" ? useLayoutEffect : useEffect;
function deepEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== typeof b) {
    return false;
  }
  if (typeof a === "function" && a.toString() === b.toString()) {
    return true;
  }
  let length;
  let i;
  let keys;
  if (a && b && typeof a === "object") {
    if (Array.isArray(a)) {
      length = a.length;
      if (length !== b.length) return false;
      for (i = length; i-- !== 0; ) {
        if (!deepEqual(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) {
      return false;
    }
    for (i = length; i-- !== 0; ) {
      if (!{}.hasOwnProperty.call(b, keys[i])) {
        return false;
      }
    }
    for (i = length; i-- !== 0; ) {
      const key = keys[i];
      if (key === "_owner" && a.$$typeof) {
        continue;
      }
      if (!deepEqual(a[key], b[key])) {
        return false;
      }
    }
    return true;
  }
  return a !== a && b !== b;
}
function getDPR(element) {
  if (typeof window === "undefined") {
    return 1;
  }
  const win = element.ownerDocument.defaultView || window;
  return win.devicePixelRatio || 1;
}
function roundByDPR(element, value) {
  const dpr = getDPR(element);
  return Math.round(value * dpr) / dpr;
}
function useLatestRef$1(value) {
  const ref = React.useRef(value);
  index$1(() => {
    ref.current = value;
  });
  return ref;
}
function useFloating$1(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2,
    elements: {
      reference: externalReference,
      floating: externalFloating
    } = {},
    transform = true,
    whileElementsMounted,
    open
  } = options;
  const [data, setData] = React.useState({
    x: 0,
    y: 0,
    strategy,
    placement,
    middlewareData: {},
    isPositioned: false
  });
  const [latestMiddleware, setLatestMiddleware] = React.useState(middleware);
  if (!deepEqual(latestMiddleware, middleware)) {
    setLatestMiddleware(middleware);
  }
  const [_reference, _setReference] = React.useState(null);
  const [_floating, _setFloating] = React.useState(null);
  const setReference = React.useCallback((node) => {
    if (node !== referenceRef.current) {
      referenceRef.current = node;
      _setReference(node);
    }
  }, []);
  const setFloating = React.useCallback((node) => {
    if (node !== floatingRef.current) {
      floatingRef.current = node;
      _setFloating(node);
    }
  }, []);
  const referenceEl = externalReference || _reference;
  const floatingEl = externalFloating || _floating;
  const referenceRef = React.useRef(null);
  const floatingRef = React.useRef(null);
  const dataRef = React.useRef(data);
  const hasWhileElementsMounted = whileElementsMounted != null;
  const whileElementsMountedRef = useLatestRef$1(whileElementsMounted);
  const platformRef = useLatestRef$1(platform2);
  const openRef = useLatestRef$1(open);
  const update = React.useCallback(() => {
    if (!referenceRef.current || !floatingRef.current) {
      return;
    }
    const config = {
      placement,
      strategy,
      middleware: latestMiddleware
    };
    if (platformRef.current) {
      config.platform = platformRef.current;
    }
    computePosition(referenceRef.current, floatingRef.current, config).then((data2) => {
      const fullData = {
        ...data2,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: openRef.current !== false
      };
      if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
        dataRef.current = fullData;
        ReactDOM.flushSync(() => {
          setData(fullData);
        });
      }
    });
  }, [latestMiddleware, placement, strategy, platformRef, openRef]);
  index$1(() => {
    if (open === false && dataRef.current.isPositioned) {
      dataRef.current.isPositioned = false;
      setData((data2) => ({
        ...data2,
        isPositioned: false
      }));
    }
  }, [open]);
  const isMountedRef = React.useRef(false);
  index$1(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  index$1(() => {
    if (referenceEl) referenceRef.current = referenceEl;
    if (floatingEl) floatingRef.current = floatingEl;
    if (referenceEl && floatingEl) {
      if (whileElementsMountedRef.current) {
        return whileElementsMountedRef.current(referenceEl, floatingEl, update);
      }
      update();
    }
  }, [referenceEl, floatingEl, update, whileElementsMountedRef, hasWhileElementsMounted]);
  const refs = React.useMemo(() => ({
    reference: referenceRef,
    floating: floatingRef,
    setReference,
    setFloating
  }), [setReference, setFloating]);
  const elements = React.useMemo(() => ({
    reference: referenceEl,
    floating: floatingEl
  }), [referenceEl, floatingEl]);
  const floatingStyles = React.useMemo(() => {
    const initialStyles = {
      position: strategy,
      left: 0,
      top: 0
    };
    if (!elements.floating) {
      return initialStyles;
    }
    const x = roundByDPR(elements.floating, data.x);
    const y = roundByDPR(elements.floating, data.y);
    if (transform) {
      return {
        ...initialStyles,
        transform: "translate(" + x + "px, " + y + "px)",
        ...getDPR(elements.floating) >= 1.5 && {
          willChange: "transform"
        }
      };
    }
    return {
      position: strategy,
      left: x,
      top: y
    };
  }, [strategy, transform, elements.floating, data.x, data.y]);
  return React.useMemo(() => ({
    ...data,
    update,
    refs,
    elements,
    floatingStyles
  }), [data, update, refs, elements, floatingStyles]);
}
const offset = (options, deps) => ({
  ...offset$1(options),
  options: [options, deps]
});
const shift = (options, deps) => ({
  ...shift$1(options),
  options: [options, deps]
});
const flip = (options, deps) => ({
  ...flip$1(options),
  options: [options, deps]
});
const hide = (options, deps) => ({
  ...hide$1(options),
  options: [options, deps]
});
const SafeReact = {
  ...React
};
const useInsertionEffect = SafeReact.useInsertionEffect;
const useSafeInsertionEffect = useInsertionEffect || ((fn) => fn());
function useEffectEvent(callback) {
  const ref = React.useRef(() => {
    if (process.env.NODE_ENV !== "production") {
      throw new Error("Cannot call an event handler while rendering.");
    }
  });
  useSafeInsertionEffect(() => {
    ref.current = callback;
  });
  return React.useCallback(function() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ref.current == null ? void 0 : ref.current(...args);
  }, []);
}
var index = typeof document !== "undefined" ? useLayoutEffect : useEffect;
let serverHandoffComplete = false;
let count = 0;
const genId = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + count++
);
function useFloatingId() {
  const [id, setId] = React.useState(() => serverHandoffComplete ? genId() : void 0);
  index(() => {
    if (id == null) {
      setId(genId());
    }
  }, []);
  React.useEffect(() => {
    serverHandoffComplete = true;
  }, []);
  return id;
}
const useReactId = SafeReact.useId;
const useId = useReactId || useFloatingId;
let devMessageSet;
if (process.env.NODE_ENV !== "production") {
  devMessageSet = /* @__PURE__ */ new Set();
}
function error() {
  var _devMessageSet3;
  for (var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    messages[_key2] = arguments[_key2];
  }
  const message = "Floating UI: " + messages.join(" ");
  if (!((_devMessageSet3 = devMessageSet) != null && _devMessageSet3.has(message))) {
    var _devMessageSet4;
    (_devMessageSet4 = devMessageSet) == null || _devMessageSet4.add(message);
    console.error(message);
  }
}
function createPubSub() {
  const map = /* @__PURE__ */ new Map();
  return {
    emit(event, data) {
      var _map$get;
      (_map$get = map.get(event)) == null || _map$get.forEach((handler) => handler(data));
    },
    on(event, listener) {
      map.set(event, [...map.get(event) || [], listener]);
    },
    off(event, listener) {
      var _map$get2;
      map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter((l) => l !== listener)) || []);
    }
  };
}
const FloatingNodeContext = /* @__PURE__ */ React.createContext(null);
const FloatingTreeContext = /* @__PURE__ */ React.createContext(null);
const useFloatingParentNodeId = () => {
  var _React$useContext;
  return ((_React$useContext = React.useContext(FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
const useFloatingTree = () => React.useContext(FloatingTreeContext);
function createAttribute(name) {
  return "data-floating-ui-" + name;
}
function useLatestRef(value) {
  const ref = useRef(value);
  index(() => {
    ref.current = value;
  });
  return ref;
}
function getChildren(nodes, id) {
  let allChildren = nodes.filter((node) => {
    var _node$context;
    return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
  });
  let currentChildren = allChildren;
  while (currentChildren.length) {
    currentChildren = nodes.filter((node) => {
      var _currentChildren;
      return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some((n) => {
        var _node$context2;
        return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
      });
    });
    allChildren = allChildren.concat(currentChildren);
  }
  return allChildren;
}
const FOCUSABLE_ATTRIBUTE = "data-floating-ui-focusable";
const bubbleHandlerKeys = {
  pointerdown: "onPointerDown",
  mousedown: "onMouseDown",
  click: "onClick"
};
const captureHandlerKeys = {
  pointerdown: "onPointerDownCapture",
  mousedown: "onMouseDownCapture",
  click: "onClickCapture"
};
const normalizeProp = (normalizable) => {
  var _normalizable$escapeK, _normalizable$outside;
  return {
    escapeKey: typeof normalizable === "boolean" ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
    outsidePress: typeof normalizable === "boolean" ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
  };
};
function useDismiss(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    elements,
    dataRef
  } = context;
  const {
    enabled = true,
    escapeKey = true,
    outsidePress: unstable_outsidePress = true,
    outsidePressEvent = "pointerdown",
    referencePress = false,
    referencePressEvent = "pointerdown",
    ancestorScroll = false,
    bubbles,
    capture
  } = props;
  const tree = useFloatingTree();
  const outsidePressFn = useEffectEvent(typeof unstable_outsidePress === "function" ? unstable_outsidePress : () => false);
  const outsidePress = typeof unstable_outsidePress === "function" ? outsidePressFn : unstable_outsidePress;
  const insideReactTreeRef = React.useRef(false);
  const endedOrStartedInsideRef = React.useRef(false);
  const {
    escapeKey: escapeKeyBubbles,
    outsidePress: outsidePressBubbles
  } = normalizeProp(bubbles);
  const {
    escapeKey: escapeKeyCapture,
    outsidePress: outsidePressCapture
  } = normalizeProp(capture);
  const isComposingRef = React.useRef(false);
  const closeOnEscapeKeyDown = useEffectEvent((event) => {
    var _dataRef$current$floa;
    if (!open || !enabled || !escapeKey || event.key !== "Escape") {
      return;
    }
    if (isComposingRef.current) {
      return;
    }
    const nodeId = (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
    const children = tree ? getChildren(tree.nodesRef.current, nodeId) : [];
    if (!escapeKeyBubbles) {
      event.stopPropagation();
      if (children.length > 0) {
        let shouldDismiss = true;
        children.forEach((child) => {
          var _child$context;
          if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
            shouldDismiss = false;
            return;
          }
        });
        if (!shouldDismiss) {
          return;
        }
      }
    }
    onOpenChange(false, isReactEvent(event) ? event.nativeEvent : event, "escape-key");
  });
  const closeOnEscapeKeyDownCapture = useEffectEvent((event) => {
    var _getTarget2;
    const callback = () => {
      var _getTarget;
      closeOnEscapeKeyDown(event);
      (_getTarget = getTarget(event)) == null || _getTarget.removeEventListener("keydown", callback);
    };
    (_getTarget2 = getTarget(event)) == null || _getTarget2.addEventListener("keydown", callback);
  });
  const closeOnPressOutside = useEffectEvent((event) => {
    var _dataRef$current$floa2;
    const insideReactTree = insideReactTreeRef.current;
    insideReactTreeRef.current = false;
    const endedOrStartedInside = endedOrStartedInsideRef.current;
    endedOrStartedInsideRef.current = false;
    if (outsidePressEvent === "click" && endedOrStartedInside) {
      return;
    }
    if (insideReactTree) {
      return;
    }
    if (typeof outsidePress === "function" && !outsidePress(event)) {
      return;
    }
    const target = getTarget(event);
    const inertSelector = "[" + createAttribute("inert") + "]";
    const markers = getDocument(elements.floating).querySelectorAll(inertSelector);
    let targetRootAncestor = isElement(target) ? target : null;
    while (targetRootAncestor && !isLastTraversableNode(targetRootAncestor)) {
      const nextParent = getParentNode(targetRootAncestor);
      if (isLastTraversableNode(nextParent) || !isElement(nextParent)) {
        break;
      }
      targetRootAncestor = nextParent;
    }
    if (markers.length && isElement(target) && !isRootElement(target) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !contains(target, elements.floating) && // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(markers).every((marker) => !contains(targetRootAncestor, marker))) {
      return;
    }
    if (isHTMLElement(target) && floating) {
      const canScrollX = target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
      const canScrollY = target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
      let xCond = canScrollY && event.offsetX > target.clientWidth;
      if (canScrollY) {
        const isRTL2 = getComputedStyle(target).direction === "rtl";
        if (isRTL2) {
          xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
        }
      }
      if (xCond || canScrollX && event.offsetY > target.clientHeight) {
        return;
      }
    }
    const nodeId = (_dataRef$current$floa2 = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa2.nodeId;
    const targetIsInsideChildren = tree && getChildren(tree.nodesRef.current, nodeId).some((node) => {
      var _node$context;
      return isEventTargetWithin(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
    });
    if (isEventTargetWithin(event, elements.floating) || isEventTargetWithin(event, elements.domReference) || targetIsInsideChildren) {
      return;
    }
    const children = tree ? getChildren(tree.nodesRef.current, nodeId) : [];
    if (children.length > 0) {
      let shouldDismiss = true;
      children.forEach((child) => {
        var _child$context2;
        if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
          shouldDismiss = false;
          return;
        }
      });
      if (!shouldDismiss) {
        return;
      }
    }
    onOpenChange(false, event, "outside-press");
  });
  const closeOnPressOutsideCapture = useEffectEvent((event) => {
    var _getTarget4;
    const callback = () => {
      var _getTarget3;
      closeOnPressOutside(event);
      (_getTarget3 = getTarget(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
    };
    (_getTarget4 = getTarget(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
  });
  React.useEffect(() => {
    if (!open || !enabled) {
      return;
    }
    dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
    dataRef.current.__outsidePressBubbles = outsidePressBubbles;
    let compositionTimeout = -1;
    function onScroll(event) {
      onOpenChange(false, event, "ancestor-scroll");
    }
    function handleCompositionStart() {
      window.clearTimeout(compositionTimeout);
      isComposingRef.current = true;
    }
    function handleCompositionEnd() {
      compositionTimeout = window.setTimeout(
        () => {
          isComposingRef.current = false;
        },
        // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
        // Only apply to WebKit for the test to remain 0ms.
        isWebKit() ? 5 : 0
      );
    }
    const doc = getDocument(elements.floating);
    if (escapeKey) {
      doc.addEventListener("keydown", escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
      doc.addEventListener("compositionstart", handleCompositionStart);
      doc.addEventListener("compositionend", handleCompositionEnd);
    }
    outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
    let ancestors = [];
    if (ancestorScroll) {
      if (isElement(elements.domReference)) {
        ancestors = getOverflowAncestors(elements.domReference);
      }
      if (isElement(elements.floating)) {
        ancestors = ancestors.concat(getOverflowAncestors(elements.floating));
      }
      if (!isElement(elements.reference) && elements.reference && elements.reference.contextElement) {
        ancestors = ancestors.concat(getOverflowAncestors(elements.reference.contextElement));
      }
    }
    ancestors = ancestors.filter((ancestor) => {
      var _doc$defaultView;
      return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
    });
    ancestors.forEach((ancestor) => {
      ancestor.addEventListener("scroll", onScroll, {
        passive: true
      });
    });
    return () => {
      if (escapeKey) {
        doc.removeEventListener("keydown", escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
        doc.removeEventListener("compositionstart", handleCompositionStart);
        doc.removeEventListener("compositionend", handleCompositionEnd);
      }
      outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
      ancestors.forEach((ancestor) => {
        ancestor.removeEventListener("scroll", onScroll);
      });
      window.clearTimeout(compositionTimeout);
    };
  }, [dataRef, elements, escapeKey, outsidePress, outsidePressEvent, open, onOpenChange, ancestorScroll, enabled, escapeKeyBubbles, outsidePressBubbles, closeOnEscapeKeyDown, escapeKeyCapture, closeOnEscapeKeyDownCapture, closeOnPressOutside, outsidePressCapture, closeOnPressOutsideCapture]);
  React.useEffect(() => {
    insideReactTreeRef.current = false;
  }, [outsidePress, outsidePressEvent]);
  const reference = React.useMemo(() => ({
    onKeyDown: closeOnEscapeKeyDown,
    [bubbleHandlerKeys[referencePressEvent]]: (event) => {
      if (referencePress) {
        onOpenChange(false, event.nativeEvent, "reference-press");
      }
    }
  }), [closeOnEscapeKeyDown, onOpenChange, referencePress, referencePressEvent]);
  const floating = React.useMemo(() => ({
    onKeyDown: closeOnEscapeKeyDown,
    onMouseDown() {
      endedOrStartedInsideRef.current = true;
    },
    onMouseUp() {
      endedOrStartedInsideRef.current = true;
    },
    [captureHandlerKeys[outsidePressEvent]]: () => {
      insideReactTreeRef.current = true;
    }
  }), [closeOnEscapeKeyDown, outsidePressEvent]);
  return React.useMemo(() => enabled ? {
    reference,
    floating
  } : {}, [enabled, reference, floating]);
}
function useFloatingRootContext(options) {
  const {
    open = false,
    onOpenChange: onOpenChangeProp,
    elements: elementsProp
  } = options;
  const floatingId = useId();
  const dataRef = React.useRef({});
  const [events] = React.useState(() => createPubSub());
  const nested = useFloatingParentNodeId() != null;
  if (process.env.NODE_ENV !== "production") {
    const optionDomReference = elementsProp.reference;
    if (optionDomReference && !isElement(optionDomReference)) {
      error("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
    }
  }
  const [positionReference, setPositionReference] = React.useState(elementsProp.reference);
  const onOpenChange = useEffectEvent((open2, event, reason) => {
    dataRef.current.openEvent = open2 ? event : void 0;
    events.emit("openchange", {
      open: open2,
      event,
      reason,
      nested
    });
    onOpenChangeProp == null || onOpenChangeProp(open2, event, reason);
  });
  const refs = React.useMemo(() => ({
    setPositionReference
  }), []);
  const elements = React.useMemo(() => ({
    reference: positionReference || elementsProp.reference || null,
    floating: elementsProp.floating || null,
    domReference: elementsProp.reference
  }), [positionReference, elementsProp.reference, elementsProp.floating]);
  return React.useMemo(() => ({
    dataRef,
    open,
    onOpenChange,
    elements,
    events,
    floatingId,
    refs
  }), [open, onOpenChange, elements, events, floatingId, refs]);
}
function useFloating(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    nodeId
  } = options;
  const internalRootContext = useFloatingRootContext({
    ...options,
    elements: {
      reference: null,
      floating: null,
      ...options.elements
    }
  });
  const rootContext = options.rootContext || internalRootContext;
  const computedElements = rootContext.elements;
  const [_domReference, setDomReference] = React.useState(null);
  const [positionReference, _setPositionReference] = React.useState(null);
  const optionDomReference = computedElements == null ? void 0 : computedElements.domReference;
  const domReference = optionDomReference || _domReference;
  const domReferenceRef = React.useRef(null);
  const tree = useFloatingTree();
  index(() => {
    if (domReference) {
      domReferenceRef.current = domReference;
    }
  }, [domReference]);
  const position = useFloating$1({
    ...options,
    elements: {
      ...computedElements,
      ...positionReference && {
        reference: positionReference
      }
    }
  });
  const setPositionReference = React.useCallback((node) => {
    const computedPositionReference = isElement(node) ? {
      getBoundingClientRect: () => node.getBoundingClientRect(),
      contextElement: node
    } : node;
    _setPositionReference(computedPositionReference);
    position.refs.setReference(computedPositionReference);
  }, [position.refs]);
  const setReference = React.useCallback((node) => {
    if (isElement(node) || node === null) {
      domReferenceRef.current = node;
      setDomReference(node);
    }
    if (isElement(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    node !== null && !isElement(node)) {
      position.refs.setReference(node);
    }
  }, [position.refs]);
  const refs = React.useMemo(() => ({
    ...position.refs,
    setReference,
    setPositionReference,
    domReference: domReferenceRef
  }), [position.refs, setReference, setPositionReference]);
  const elements = React.useMemo(() => ({
    ...position.elements,
    domReference
  }), [position.elements, domReference]);
  const context = React.useMemo(() => ({
    ...position,
    ...rootContext,
    refs,
    elements,
    nodeId
  }), [position, refs, elements, nodeId, rootContext]);
  index(() => {
    rootContext.dataRef.current.floatingContext = context;
    const node = tree == null ? void 0 : tree.nodesRef.current.find((node2) => node2.id === nodeId);
    if (node) {
      node.context = context;
    }
  });
  return React.useMemo(() => ({
    ...position,
    context,
    refs,
    elements
  }), [position, refs, elements, context]);
}
const ACTIVE_KEY = "active";
const SELECTED_KEY = "selected";
function mergeProps(userProps, propsList, elementKey) {
  const map = /* @__PURE__ */ new Map();
  const isItem = elementKey === "item";
  let domUserProps = userProps;
  if (isItem && userProps) {
    const {
      [ACTIVE_KEY]: _,
      [SELECTED_KEY]: __,
      ...validProps
    } = userProps;
    domUserProps = validProps;
  }
  return {
    ...elementKey === "floating" && {
      tabIndex: -1,
      [FOCUSABLE_ATTRIBUTE]: ""
    },
    ...domUserProps,
    ...propsList.map((value) => {
      const propsOrGetProps = value ? value[elementKey] : null;
      if (typeof propsOrGetProps === "function") {
        return userProps ? propsOrGetProps(userProps) : null;
      }
      return propsOrGetProps;
    }).concat(userProps).reduce((acc, props) => {
      if (!props) {
        return acc;
      }
      Object.entries(props).forEach((_ref) => {
        let [key, value] = _ref;
        if (isItem && [ACTIVE_KEY, SELECTED_KEY].includes(key)) {
          return;
        }
        if (key.indexOf("on") === 0) {
          if (!map.has(key)) {
            map.set(key, []);
          }
          if (typeof value === "function") {
            var _map$get;
            (_map$get = map.get(key)) == null || _map$get.push(value);
            acc[key] = function() {
              var _map$get2;
              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }
              return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map((fn) => fn(...args)).find((val) => val !== void 0);
            };
          }
        } else {
          acc[key] = value;
        }
      });
      return acc;
    }, {})
  };
}
function useInteractions(propsList) {
  if (propsList === void 0) {
    propsList = [];
  }
  const referenceDeps = propsList.map((key) => key == null ? void 0 : key.reference);
  const floatingDeps = propsList.map((key) => key == null ? void 0 : key.floating);
  const itemDeps = propsList.map((key) => key == null ? void 0 : key.item);
  const getReferenceProps = React.useCallback(
    (userProps) => mergeProps(userProps, propsList, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    referenceDeps
  );
  const getFloatingProps = React.useCallback(
    (userProps) => mergeProps(userProps, propsList, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    floatingDeps
  );
  const getItemProps = React.useCallback(
    (userProps) => mergeProps(userProps, propsList, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    itemDeps
  );
  return React.useMemo(() => ({
    getReferenceProps,
    getFloatingProps,
    getItemProps
  }), [getReferenceProps, getFloatingProps, getItemProps]);
}
const componentRoleToAriaRoleMap = /* @__PURE__ */ new Map([["select", "listbox"], ["combobox", "listbox"], ["label", false]]);
function useRole(context, props) {
  var _componentRoleToAriaR;
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    floatingId
  } = context;
  const {
    enabled = true,
    role = "dialog"
  } = props;
  const ariaRole = (_componentRoleToAriaR = componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
  const referenceId = useId();
  const parentId = useFloatingParentNodeId();
  const isNested = parentId != null;
  const reference = React.useMemo(() => {
    if (ariaRole === "tooltip" || role === "label") {
      return {
        ["aria-" + (role === "label" ? "labelledby" : "describedby")]: open ? floatingId : void 0
      };
    }
    return {
      "aria-expanded": open ? "true" : "false",
      "aria-haspopup": ariaRole === "alertdialog" ? "dialog" : ariaRole,
      "aria-controls": open ? floatingId : void 0,
      ...ariaRole === "listbox" && {
        role: "combobox"
      },
      ...ariaRole === "menu" && {
        id: referenceId
      },
      ...ariaRole === "menu" && isNested && {
        role: "menuitem"
      },
      ...role === "select" && {
        "aria-autocomplete": "none"
      },
      ...role === "combobox" && {
        "aria-autocomplete": "list"
      }
    };
  }, [ariaRole, floatingId, isNested, open, referenceId, role]);
  const floating = React.useMemo(() => {
    const floatingProps = {
      id: floatingId,
      ...ariaRole && {
        role: ariaRole
      }
    };
    if (ariaRole === "tooltip" || role === "label") {
      return floatingProps;
    }
    return {
      ...floatingProps,
      ...ariaRole === "menu" && {
        "aria-labelledby": referenceId
      }
    };
  }, [ariaRole, floatingId, referenceId, role]);
  const item = React.useCallback((_ref) => {
    let {
      active,
      selected
    } = _ref;
    const commonProps = {
      role: "option",
      ...active && {
        id: floatingId + "-option"
      }
    };
    switch (role) {
      case "select":
        return {
          ...commonProps,
          "aria-selected": active && selected
        };
      case "combobox": {
        return {
          ...commonProps,
          ...active && {
            "aria-selected": true
          }
        };
      }
    }
    return {};
  }, [floatingId, role]);
  return React.useMemo(() => enabled ? {
    reference,
    floating,
    item
  } : {}, [enabled, reference, floating, item]);
}
const camelCaseToKebabCase = (str) => str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs) => (ofs ? "-" : "") + $.toLowerCase());
function execWithArgsOrReturn(valueOrFn, args) {
  return typeof valueOrFn === "function" ? valueOrFn(args) : valueOrFn;
}
function useDelayUnmount(open, durationMs) {
  const [isMounted, setIsMounted] = React.useState(open);
  if (open && !isMounted) {
    setIsMounted(true);
  }
  React.useEffect(() => {
    if (!open && isMounted) {
      const timeout = setTimeout(() => setIsMounted(false), durationMs);
      return () => clearTimeout(timeout);
    }
  }, [open, isMounted, durationMs]);
  return isMounted;
}
function useTransitionStatus(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    elements: {
      floating
    }
  } = context;
  const {
    duration = 250
  } = props;
  const isNumberDuration = typeof duration === "number";
  const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
  const [status, setStatus] = React.useState("unmounted");
  const isMounted = useDelayUnmount(open, closeDuration);
  if (!isMounted && status === "close") {
    setStatus("unmounted");
  }
  index(() => {
    if (!floating) return;
    if (open) {
      setStatus("initial");
      const frame = requestAnimationFrame(() => {
        setStatus("open");
      });
      return () => {
        cancelAnimationFrame(frame);
      };
    }
    setStatus("close");
  }, [open, floating]);
  return {
    isMounted,
    status
  };
}
function useTransitionStyles(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    initial: unstable_initial = {
      opacity: 0
    },
    open: unstable_open,
    close: unstable_close,
    common: unstable_common,
    duration = 250
  } = props;
  const placement = context.placement;
  const side = placement.split("-")[0];
  const fnArgs = React.useMemo(() => ({
    side,
    placement
  }), [side, placement]);
  const isNumberDuration = typeof duration === "number";
  const openDuration = (isNumberDuration ? duration : duration.open) || 0;
  const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
  const [styles, setStyles] = React.useState(() => ({
    ...execWithArgsOrReturn(unstable_common, fnArgs),
    ...execWithArgsOrReturn(unstable_initial, fnArgs)
  }));
  const {
    isMounted,
    status
  } = useTransitionStatus(context, {
    duration
  });
  const initialRef = useLatestRef(unstable_initial);
  const openRef = useLatestRef(unstable_open);
  const closeRef = useLatestRef(unstable_close);
  const commonRef = useLatestRef(unstable_common);
  index(() => {
    const initialStyles = execWithArgsOrReturn(initialRef.current, fnArgs);
    const closeStyles = execWithArgsOrReturn(closeRef.current, fnArgs);
    const commonStyles = execWithArgsOrReturn(commonRef.current, fnArgs);
    const openStyles = execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key) => {
      acc[key] = "";
      return acc;
    }, {});
    if (status === "initial") {
      setStyles((styles2) => ({
        transitionProperty: styles2.transitionProperty,
        ...commonStyles,
        ...initialStyles
      }));
    }
    if (status === "open") {
      setStyles({
        transitionProperty: Object.keys(openStyles).map(camelCaseToKebabCase).join(","),
        transitionDuration: openDuration + "ms",
        ...commonStyles,
        ...openStyles
      });
    }
    if (status === "close") {
      const styles2 = closeStyles || initialStyles;
      setStyles({
        transitionProperty: Object.keys(styles2).map(camelCaseToKebabCase).join(","),
        transitionDuration: closeDuration + "ms",
        ...commonStyles,
        ...styles2
      });
    }
  }, [closeDuration, closeRef, initialRef, openRef, commonRef, openDuration, status, fnArgs]);
  return {
    isMounted,
    styles
  };
}
const getSpinnerSize = (size) => {
  switch (size) {
    case "xxsmall":
      return 16;
    case "xsmall":
      return 20;
    case "small":
      return 24;
    case "medium":
      return 48;
    case "large":
    default:
      return 96;
  }
};
const getStrokeSize = (size) => {
  switch (size) {
    case "xxsmall":
    case "xsmall":
      return getSpinnerSize(size) / 5;
    case "small":
    case "medium":
      return getSpinnerSize(size) / 6;
    case "large":
    default:
      return getSpinnerSize(size) / 10;
  }
};
const LoadingIndicatorSpinner = forwardRef(
  ({
    size = "large",
    loadingText,
    colorVariant = "onWhite",
    className,
    ...props
  }, ref) => {
    const spinnerSize = getSpinnerSize(size);
    const stroke = getStrokeSize(size);
    const cx = spinnerSize / 2;
    const cy = spinnerSize / 2;
    const innerRadius = spinnerSize / 2 - stroke / 2;
    return /* @__PURE__ */ jsxs(
      "div",
      {
        ...props,
        className: `spinnerContainer ${size} ${colorVariant}${className ? ` ${className}` : ""}`,
        "data-stb-spinner": "true",
        "data-component-info": "pretzel-spinner",
        role: "progressbar",
        "aria-busy": true,
        "aria-label": loadingText ?? "Loading...",
        ref,
        children: [
          /* @__PURE__ */ jsxs(
            "svg",
            {
              className: `spinner ${colorVariant}`,
              version: "1.1",
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: `0 0 ${spinnerSize} ${spinnerSize}`,
              height: spinnerSize,
              width: spinnerSize,
              children: [
                /* @__PURE__ */ jsx(
                  "circle",
                  {
                    className: "spinnerTrack",
                    cx,
                    cy: cx,
                    r: innerRadius,
                    fill: "none",
                    strokeWidth: stroke
                  }
                ),
                /* @__PURE__ */ jsx(
                  "circle",
                  {
                    className: "spinnerInMotion",
                    cx,
                    cy,
                    r: innerRadius,
                    fill: "none",
                    strokeWidth: stroke
                  }
                )
              ]
            }
          ),
          loadingText && size === "large" && /* @__PURE__ */ jsx("p", { className: "font-body", children: loadingText }),
          loadingText && size === "medium" && /* @__PURE__ */ jsx("p", { className: "font-small", children: loadingText })
        ]
      }
    );
  }
);
const buttonFontClassFrom = (size) => {
  switch (size) {
    case "large":
      return "font-button";
    case "small":
      return "font-button-small";
    case "medium":
    default:
      return "font-button-mobile";
  }
};
const toSpinnerSize = (size) => {
  switch (size) {
    case "small":
      return "xxsmall";
    case "medium":
      return "xsmall";
    case "large":
    default:
      return "small";
  }
};
const fixedForwardRef = forwardRef;
function ButtonWithForwardRef(props, ref) {
  const {
    disabled,
    variant = "primary",
    loading = false,
    iconLeft = "",
    iconRight = "",
    showDefaultIcon = true,
    onClick,
    children,
    size = "large",
    type = "button",
    className,
    id,
    as: Element2 = "button",
    ...rest
  } = props;
  const shouldHaveDefaultIcon = showDefaultIcon && variant === "tertiary" && !iconRight && !iconLeft;
  const shouldBeUnderlined = variant === "tertiary" && !iconRight && !iconLeft && !shouldHaveDefaultIcon;
  function handleClick() {
    if (disabled || loading) {
      return (e) => e.preventDefault();
    }
    return onClick;
  }
  function renderLoading() {
    return loading && /* @__PURE__ */ jsx(
      LoadingIndicatorSpinner,
      {
        size: toSpinnerSize(size),
        colorVariant: "onRed"
      }
    );
  }
  function renderContent() {
    return !loading && /* @__PURE__ */ jsxs(Fragment, { children: [
      iconLeft && /* @__PURE__ */ jsx("i", { className: "systemIcon iconLeft", translate: "no", "aria-hidden": true, children: iconLeft }),
      children && /* @__PURE__ */ jsx("span", { children }),
      shouldHaveDefaultIcon && /* @__PURE__ */ jsx("i", { className: "systemIcon iconRight", translate: "no", "aria-hidden": true, children: "arrow_right" }),
      iconRight && /* @__PURE__ */ jsx("i", { className: "systemIcon iconRight", translate: "no", "aria-hidden": true, children: iconRight })
    ] });
  }
  return /* @__PURE__ */ jsxs(
    Element2,
    {
      ...rest,
      id,
      ref,
      "data-stb-button": "true",
      "data-component-info": "pretzel-button",
      "data-loading": loading ? true : null,
      "data-variant": variant,
      "data-size": size,
      "aria-disabled": disabled,
      role: Element2 === "a" ? "link" : null,
      onClick: handleClick(),
      type: Element2 === "button" ? type : void 0,
      disabled,
      className: `button font-button-large ${buttonFontClassFrom(size)}${shouldBeUnderlined ? " underlined" : ""}${className ? ` ${className}` : ""}`,
      tabIndex: "0",
      href: Element2 === "a" ? rest.href : void 0,
      children: [
        renderLoading(),
        renderContent()
      ]
    }
  );
}
fixedForwardRef(ButtonWithForwardRef);
function ButtonBrandWithForwardedRef(props, ref) {
  const {
    disabled,
    loading = false,
    iconLeft = "",
    iconRight = "",
    onClick,
    children,
    as = "button",
    type = "button",
    className,
    as: Element2 = "button",
    ...rest
  } = props;
  function handleClick() {
    if (disabled || loading) {
      return (e) => e.preventDefault();
    }
    return onClick;
  }
  function renderLoading() {
    return loading && /* @__PURE__ */ jsx(LoadingIndicatorSpinner, { size: "small", colorVariant: "onRed" });
  }
  function renderContent() {
    return !loading && /* @__PURE__ */ jsxs(Fragment, { children: [
      iconLeft && /* @__PURE__ */ jsx("i", { className: "systemIcon iconLeft", translate: "no", "aria-hidden": true, children: iconLeft }),
      /* @__PURE__ */ jsx("span", { children }),
      iconRight && /* @__PURE__ */ jsx("i", { className: "systemIcon iconRight", translate: "no", "aria-hidden": true, children: iconRight })
    ] });
  }
  return /* @__PURE__ */ jsxs(
    Element2,
    {
      ...rest,
      ref,
      "data-stb-button-brand": "true",
      "data-component-info": "pretzel-button-brand",
      "data-loading": loading ? true : null,
      "aria-disabled": disabled,
      role: as === "a" ? "link" : null,
      onClick: handleClick(),
      type: as === "button" ? type : void 0,
      disabled,
      className: `buttonBrand font-button-large${className ? ` ${className}` : ""}`,
      tabIndex: "0",
      href: Element2 === "a" ? rest.href : void 0,
      children: [
        renderLoading(),
        renderContent()
      ]
    }
  );
}
fixedForwardRef(ButtonBrandWithForwardedRef);
function ButtonCircleWithForwardedRef(props, ref) {
  const {
    disabled,
    variant = "primary",
    loading = false,
    iconName,
    onClick,
    as = "button",
    type = "button",
    className,
    "aria-label": ariaLabel,
    as: Element2 = "button",
    size = "large",
    ...rest
  } = props;
  function handleClick() {
    if (disabled || loading) {
      return (e) => e.preventDefault();
    }
    return onClick;
  }
  function renderLoading() {
    return loading && /* @__PURE__ */ jsx(
      LoadingIndicatorSpinner,
      {
        size: toSpinnerSize(size),
        colorVariant: "onRed"
      }
    );
  }
  function renderContent() {
    return !loading && iconName && /* @__PURE__ */ jsx("i", { className: "systemIcon", translate: "no", "aria-hidden": true, children: iconName });
  }
  return /* @__PURE__ */ jsxs(
    Element2,
    {
      ...rest,
      ref,
      "data-stb-button-circle": "true",
      "data-component-info": "pretzel-button-circle",
      "data-loading": loading ? true : null,
      "data-variant": variant,
      "data-size": size,
      "aria-disabled": disabled,
      "aria-label": ariaLabel,
      role: as === "a" ? "link" : null,
      onClick: handleClick(),
      type: as === "button" ? type : void 0,
      disabled,
      className: `buttonCircle font-button-large${className ? ` ${className}` : ""}`,
      tabIndex: "0",
      href: Element2 === "a" ? rest.href : void 0,
      children: [
        renderLoading(),
        renderContent()
      ]
    }
  );
}
fixedForwardRef(ButtonCircleWithForwardedRef);
function ButtonCircleBrandWithForwardedRef(props, ref) {
  const {
    disabled,
    loading = false,
    iconName,
    onClick,
    as = "button",
    type = "button",
    className,
    "aria-label": ariaLabel,
    as: Element2 = "button",
    ...rest
  } = props;
  function handleClick() {
    if (disabled || loading) {
      return (e) => e.preventDefault();
    }
    return onClick;
  }
  function renderLoading() {
    return loading && /* @__PURE__ */ jsx(LoadingIndicatorSpinner, { size: "small", colorVariant: "onRed" });
  }
  function renderContent() {
    return !loading && iconName && /* @__PURE__ */ jsx("i", { className: "systemIcon", translate: "no", "aria-hidden": true, children: iconName });
  }
  return /* @__PURE__ */ jsxs(
    Element2,
    {
      ...rest,
      ref,
      "data-stb-button-circle-brand": "true",
      "data-component-info": "pretzel-button-circle-brand",
      "data-loading": loading ? true : null,
      "aria-disabled": disabled,
      "aria-label": ariaLabel,
      role: as === "a" ? "link" : null,
      onClick: handleClick(),
      type: as === "button" ? type : void 0,
      disabled,
      className: `buttonCircleBrand font-button-large${className ? ` ${className}` : ""}`,
      tabIndex: "0",
      href: Element2 === "a" ? rest.href : void 0,
      children: [
        renderLoading(),
        renderContent()
      ]
    }
  );
}
fixedForwardRef(
  ButtonCircleBrandWithForwardedRef
);
function ButtonIconWithForwardedRef(props, ref) {
  const {
    iconName,
    disabled,
    onClick,
    size = "medium",
    as = "button",
    type = "button",
    className,
    "aria-label": ariaLabel,
    as: Element2 = "button",
    ...rest
  } = props;
  function handleClick() {
    if (disabled) {
      return (e) => e.preventDefault();
    }
    return onClick;
  }
  return /* @__PURE__ */ jsx(
    Element2,
    {
      ...rest,
      ref,
      "data-stb-button-icon": "true",
      "data-component-info": "pretzel-button-icon",
      "aria-disabled": disabled,
      "aria-label": ariaLabel,
      role: as === "a" ? "link" : null,
      onClick: handleClick(),
      "data-size": size,
      type: as === "button" ? type : void 0,
      disabled,
      className: `buttonIcon ${className ? ` ${className}` : ""}`,
      tabIndex: "0",
      href: Element2 === "a" ? rest.href : void 0,
      children: /* @__PURE__ */ jsx("i", { "aria-hidden": true, translate: "no", children: iconName })
    }
  );
}
const ButtonIcon = fixedForwardRef(ButtonIconWithForwardedRef);
const Popover = forwardRef(
  ({
    title = "",
    placement = "right",
    showOn = "press",
    iconName = "information",
    iconButtonSize = "medium",
    iconButtonProps,
    closeButtonAriaLabel = "Lukk",
    children,
    ...props
  }, ref) => {
    const [isOpen, setIsOpen] = useState(false);
    const toggle = useCallback(() => setIsOpen(!isOpen), [isOpen]);
    const close = useCallback(() => setIsOpen(false), []);
    const { x, y, refs, strategy, context } = useFloating({
      open: isOpen,
      onOpenChange: setIsOpen,
      whileElementsMounted: autoUpdate,
      middleware: [
        shift(),
        offset(8),
        hide(),
        flip({
          fallbackPlacements: ["left", "top", "bottom"]
        })
      ],
      placement,
      strategy: "fixed"
    });
    const { getReferenceProps, getFloatingProps } = useInteractions([
      useRole(context),
      useDismiss(context)
    ]);
    const { isMounted, styles } = useTransitionStyles(context, {
      duration: 200
    });
    const popoverId = useId();
    const headerId = useId();
    const contentId = useId();
    return /* @__PURE__ */ jsxs(
      "span",
      {
        ...props,
        className: "popoverBase",
        "data-stb-popover": "true",
        ref,
        children: [
          /* @__PURE__ */ jsx(
            ButtonIcon,
            {
              "aria-label": iconName,
              size: iconButtonSize,
              variant: "icon",
              iconName,
              onClick: toggle,
              ref: refs.setReference,
              ...getReferenceProps(),
              ...iconButtonProps
            }
          ),
          isMounted && /* @__PURE__ */ jsxs(
            "span",
            {
              className: "popoverPopoverElement",
              "data-stb-popover-element": "true",
              "data-show-on": showOn,
              id: popoverId,
              ...getFloatingProps({
                ref: refs.setFloating,
                style: {
                  position: strategy,
                  top: y ?? 0,
                  left: x ?? 0,
                  ...styles
                },
                "aria-labelledby": title ? headerId : contentId,
                "aria-describedby": contentId
              }),
              children: [
                /* @__PURE__ */ jsxs("span", { className: "popoverContent", children: [
                  title && /* @__PURE__ */ jsx(
                    "span",
                    {
                      className: "font-body-large-demibold popoverContentHeader",
                      id: headerId,
                      children: title
                    }
                  ),
                  /* @__PURE__ */ jsx("span", { className: "font-body popoverContentSection", id: contentId, children })
                ] }),
                showOn === "press" && /* @__PURE__ */ jsx(
                  ButtonIcon,
                  {
                    "aria-label": closeButtonAriaLabel,
                    iconName: "close",
                    onClick: close
                  }
                )
              ]
            }
          )
        ]
      }
    );
  }
);
function Label({
  id,
  title,
  children,
  popoverChildren,
  popoverTitle,
  hint,
  hintMaxLines,
  hintReadMoreLabel,
  hintReadLessLabel,
  disabled = false,
  htmlFor,
  className,
  ...props
}) {
  const labelId = useId$1();
  const hintId = `${id || labelId}-hint-id`;
  const hasPopover = Boolean(popoverChildren && Boolean(!hint));
  return /* @__PURE__ */ jsxs(
    "label",
    {
      ...props,
      className: `font-body-demibold label${className ? ` ${className}` : ""}`,
      id: id || labelId,
      htmlFor,
      "data-stb-label": "true",
      "data-component-info": "pretzel-label",
      "data-disabled": disabled,
      "data-has-popover": hasPopover,
      children: [
        /* @__PURE__ */ jsx("span", { className: "labelTitle", children: title }),
        hasPopover && /* @__PURE__ */ jsx(
          Popover,
          {
            className: "labelIcon",
            iconName: "information",
            closeButtonAriaLabel: "Close",
            title: Boolean(popoverTitle) && popoverTitle,
            children: popoverChildren
          }
        ),
        Boolean(hint) && /* @__PURE__ */ jsx(
          Hint,
          {
            id: hintId,
            className: "labelHint",
            hintMaxLines,
            hintReadMoreLabel,
            hintReadLessLabel,
            hintDisabledStyle: disabled,
            children: hint
          }
        ),
        children
      ]
    }
  );
}
const InputField = forwardRef(
  ({
    name,
    disabled = false,
    size = "medium",
    alertMessageType,
    alertMessage,
    alertRole,
    labelText,
    className = "",
    hintText,
    hintMaxLines,
    hintReadMoreLabel,
    hintReadLessLabel,
    id,
    popoverChildren,
    popoverTitle,
    ...props
  }, ref) => {
    const containerRef = useRef(null);
    const inputId = useId$1();
    const addEvent = useCallback(() => {
      var _a, _b;
      const input = (_a = containerRef.current) == null ? void 0 : _a.querySelector("input");
      const labelContainer = (_b = containerRef.current) == null ? void 0 : _b.querySelector(
        ".label-component-container"
      );
      if (labelContainer && input) {
        const handleClick = () => {
          input.focus();
        };
        labelContainer.addEventListener("click", handleClick);
        return () => {
          labelContainer.removeEventListener("click", handleClick);
        };
      }
      return null;
    }, [containerRef]);
    useEffect(() => {
      addEvent();
    }, [addEvent]);
    return /* @__PURE__ */ jsxs(
      "div",
      {
        ref: containerRef,
        className: `inputFieldContainer${className ? ` ${className}` : ""}`,
        "aria-disabled": disabled,
        "data-size": size,
        "data-message-type": alertMessageType,
        "data-stb-input-field": "true",
        "data-component-info": "pretzel-input-field",
        children: [
          /* @__PURE__ */ jsx(
            Label,
            {
              "aria-hidden": "true",
              htmlFor: id || inputId,
              title: labelText,
              disabled,
              hint: hintText,
              hintMaxLines,
              hintReadMoreLabel,
              hintReadLessLabel,
              "aria-label": labelText,
              popoverChildren,
              popoverTitle
            }
          ),
          /* @__PURE__ */ jsx(
            Input,
            {
              ...props,
              id: id || inputId,
              alertMessageType,
              name,
              disabled,
              ref,
              size
            }
          ),
          Boolean(!disabled && alertMessageType && alertMessage) && /* @__PURE__ */ jsx(
            AlertInline,
            {
              role: alertRole,
              title: alertMessage,
              variant: alertMessageType
            }
          )
        ]
      }
    );
  }
);
export {
  InputField,
  InputField as default
};
